import Vue from "vue";
import Vuex from "vuex";
var VueCookie = require("vue-cookie");
import _acl from "./../scripts/acl";
import { collect } from "collect.js";
const acl = new Vue(_acl);
// Tell Vue to use the plugin
Vue.use(VueCookie);

Vue.use(Vuex);

function setCookie(cname, cvalue, exsecond) {
  var d = new Date();
  d.setTime(d.getTime() + exsecond * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export default new Vuex.Store({
  state: {
    user: {},
    layout: "app-layout",
    isLoading: false,
    token: "",
    permissions: [],
    roles: [],
  },
  mutations: {
    LOGIN(state, _loginResponse) {
      state.user = _loginResponse.data.user;
      state.permissions = _loginResponse.data.permissions;
      state.roles = _loginResponse.data.roles;
      state.token = _loginResponse.token;
      state.totalBallance = _loginResponse.data.total_ballance;
      localStorage.setItem("user", JSON.stringify(state.user));
      localStorage.setItem("permissions", JSON.stringify(state.permissions));
      localStorage.setItem("roles", JSON.stringify(state.roles));
      localStorage.setItem("token", _loginResponse.token);
      localStorage.setItem("total_ballance", state.totalBallance);
      // acl.setCookie("token", `${_loginResponse.token}`, 30000000000);
      window.axios.defaults.headers.common["Authorization"] =
        'Bearer ' + _loginResponse.token;
    },
    LOGOUT(state) {
      state.user = null;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("permissions");
      localStorage.removeItem("roles");
    },
    LOAD_LOCAL_USER_DATA(state) {
      state.user = JSON.parse(localStorage.getItem("user"));
      state.permissions = JSON.parse(localStorage.getItem("permissions"));
      state.roles = JSON.parse(localStorage.getItem("roles"));
      state.token = localStorage.getItem("token");
      state.totalBallance = localStorage.getItem("total_ballance");
    },
    SET_LAYOUT(state, payload) {
      state.layout = payload;
    },
    SET_ISLOADING(state, payload) {
      state.isLoading = payload;
    },
  },
  actions: {
    login({ commit }, _loginResponse) {
      commit("LOGIN", _loginResponse);
    },
    logout({ commit }) {
      commit("LOGOUT");
    },
    loadLocalUserData({ commit }) {
      commit("LOAD_LOCAL_USER_DATA");
    },
  },
  getters: {
    token(state) {
      return `${state.token}`;
    },
    isLoggedIN(state) {
      if (localStorage.getItem("token")) return true;
      return false;
    },
    isSuperAdmin(state) {
      let roles = state.roles;
      return roles.find((e) => e == "super-admin") ? true : false;
    },
    isDeveloper(state) {
      let roles = state.roles;
      return roles.find((e) => e == "Developer") ? true : false;
    },
    isSupportUser(state) {
      let roles = state.roles;
      return roles.find((e) => e == "support_jetbar") ? true : false;
    },
    layout(state) {
      return state.layout;
    },
    isLoading(state) {
      return state.isLoading;
    },
  },
  modules: {},
});
